import {DEFAULT_PAGE_SIZE} from '../../../../constants';

/**
 * The All tab's base list query.
 *
 * Lives in its own leaf module rather than in `AllTab.jsx` because `hooks/expense/useAllTab.js`
 * needs it, and the hooks barrel is imported eagerly by the app shell — so importing it from the
 * component file dragged the entire AllTab tree into the entry bundle no matter what route-level
 * code splitting did (H1MVP-4743).
 */
export const ALL_TAB_BASE_QUERY = {order_by: '-date', per_page: DEFAULT_PAGE_SIZE};

// Row changes arrive in bursts (a bulk approve updates one row per expense); this collapses them into
// one totals request.
export const ALL_TAB_TOTALS_REFRESH_DELAY_MS = 300;
